import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SendBirdProvider as SBProvider } from 'sendbird-uikit';
import 'sendbird-uikit/dist/index.css';
import { Container, Row, Col } from 'react-bootstrap';
import ChatComponent from './ChatApp';
import { getUserList, getUnreadMessageCount } from '../../actions/chat';
import { getChatAppId } from '../../helpers/session';
import '../../../assets/scss/newChat.scss';

const NewChat = () => {
    const appId = getChatAppId();
    const dispatch = useDispatch();
    const [farmUsers, setFarmUsers] = useState([]);

    const userContactList = useSelector(state => state.chat.userContactList);
    const user_id = useSelector(state => state.auth.userInfo.userId);
    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
    const themeColor = useSelector(state => state.organization.theme);

    const userId = `${user_id}`;
    const color = themeColor.primary;

    const myColorSet = {
        '--sendbird-light-primary-500': color.light,
        '--sendbird-light-primary-400': color.darker,
        '--sendbird-light-primary-300': color.light,
        '--sendbird-light-primary-200': color.lighter,
        '--sendbird-light-primary-100': "#ECECEC",
    };

    useEffect(() => {
        if (farmId) dispatch(getUserList(farmId));
    }, [farmId]);

    useEffect(() => {
        if (!userContactList) return;
        const user = userContactList.users;
        const data = [];
        if (user && user.length > 0) {
            for (const index of user) {
                const userFarms = index.farms;
                let isExist = userFarms.filter((e) => e.farm_uuid === farmId);
                if (isExist.length > 0) {
                    data.push(index.user_id.toString());
                }
                isExist = [];
            }
        }

        setFarmUsers(data);
        dispatch(getUnreadMessageCount(true));
    }, [userContactList, farmId]);

    return (
        <Container fluid>
            <Row className='w-100 m-0'>
                <Col lg={12} sm={12} className='p-0'>
                    {userId && (
                        <SBProvider
                            colorSet={myColorSet}
                            appId={appId}
                            userId={userId}
                            allowProfileEdit={true}
                            disableUserProfile={true}>
                            <ChatComponent
                                userList={farmUsers}
                                farmId={farmId}
                            />
                        </SBProvider>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default NewChat;